import { r, createSender } from '@/plugins/resource/resource'

const MODEL = 'appeals'

export const appealsApi = {
  connectWithUs: r('/connect-with-us/create/', MODEL, createSender),
}
